export enum UserEventTypeEnum {
    login = 0,
    changePassword = 1,
    addUpdatePackage = 2,
    scheduleUpdate = 3,
    createUser = 4,
    deleteUser = 5,
    createProfile = 6,
    deleteProfile = 7,
    createFolder = 8,
    moveFolder = 9,
    deleteFolder = 10,
    renameFolder = 11,
    moveInstallation = 12,
    createDashboard = 13,
    deleteDashboard = 14,
    shareDashboard = 15,
    assignToAllLicenseModule = 16,
    editLicenseModule = 17,
    createBranch = 18,
    deleteBranch = 19,
    editBranch = 20,
    editBranchInstallations = 21,
    logDownload = 22,
    forceLogDownload = 23,
    deleteUpdatePackage = 24,
    machineReset = 25,
    installationReboot = 26,
    openRemoteLinkSession = 27,
    closeRemoteLinkSession = 28,
    deleteInstallations = 29,
    smartLockActivation = 30,
    enableSmartLock = 31,
    insertSmartLockClosingCode = 32,
    generateSmartLockChallengeCode = 33,
    editOrganizationsLicenses = 34,
    forgotPasswordLinkGeneration = 35,
    forgotPasswordResetPassword = 36,
    deviceOnBoarding = 37,
}

export function GetI18nStringFromUserEventType(val: UserEventTypeEnum): string {
    return `enum.userEventsType.${UserEventTypeEnum[val]}`;
}

export function GetIconFromUserEventType(val: UserEventTypeEnum): string {
    switch (val) {
        case UserEventTypeEnum.login:
            return "sign-in-alt";
        case UserEventTypeEnum.changePassword:
            return "key";
        case UserEventTypeEnum.addUpdatePackage:
            return "file-archive";
        case UserEventTypeEnum.scheduleUpdate:
            return "calendar-check";
        case UserEventTypeEnum.createUser:
            return "user-plus";
        case UserEventTypeEnum.deleteUser:
            return "user-slash";
        case UserEventTypeEnum.createProfile:
            return "users";
        case UserEventTypeEnum.deleteProfile:
            return "users-slash";
        case UserEventTypeEnum.createFolder:
            return "folder-plus";
        case UserEventTypeEnum.moveFolder:
            return "external-link-alt";
        case UserEventTypeEnum.deleteFolder:
            return "folder-minus";
        case UserEventTypeEnum.renameFolder:
            return "italic";
        case UserEventTypeEnum.moveInstallation:
            return "external-link-alt";
        case UserEventTypeEnum.createDashboard:
            return "calendar-plus";
        case UserEventTypeEnum.deleteDashboard:
            return "calendar-minus";
        case UserEventTypeEnum.shareDashboard:
            return "share-alt";
        case UserEventTypeEnum.assignToAllLicenseModule:
            return "cubes";
        case UserEventTypeEnum.editLicenseModule:
            return "cube";
        case UserEventTypeEnum.createBranch:
            return "store";
        case UserEventTypeEnum.deleteBranch:
            return "store-slash";
        case UserEventTypeEnum.editBranch:
            return "store";
        case UserEventTypeEnum.editBranchInstallations:
            return "store";
        case UserEventTypeEnum.logDownload:
            return "file-download";
        case UserEventTypeEnum.forceLogDownload:
            return "file-download";
        case UserEventTypeEnum.deleteUpdatePackage:
            return "file-archive";
        case UserEventTypeEnum.machineReset:
            return "wrench";
        case UserEventTypeEnum.installationReboot:
            return "redo";
        case UserEventTypeEnum.openRemoteLinkSession:
            return "link";
        case UserEventTypeEnum.closeRemoteLinkSession:
            return "unlink";
        case UserEventTypeEnum.deleteInstallations:
            return "trash";
        case UserEventTypeEnum.smartLockActivation:
            return "lock";
        case UserEventTypeEnum.enableSmartLock:
            return "lock-open";
        case UserEventTypeEnum.insertSmartLockClosingCode:
            return "unlock-alt";
        case UserEventTypeEnum.generateSmartLockChallengeCode:
            return "key";
        case UserEventTypeEnum.editOrganizationsLicenses:
            return "file-invoice-dollar";
        case UserEventTypeEnum.forgotPasswordLinkGeneration:
            return "link";
        case UserEventTypeEnum.forgotPasswordResetPassword:
            return "key";
        case UserEventTypeEnum.deviceOnBoarding:
            return "cloud-upload-alt";
        default:
            return "server";
    }
}
